export const environment = {
  production: false,
  staging: true,

  apiLogin: 'https://staging.asgcare.dk/api/login',
  apiResetPassword: 'https://staging.asgcare.dk/api/reset-password',

  apiLogOut: 'https://staging.asgcare.dk/api/authentication/logout',

  apiGetUsers: 'https://staging.asgcare.dk/api/users/getAll',
  apiGetUserByID: 'https://staging.asgcare.dk/api/users/get/',
  apiCreateUser: 'https://staging.asgcare.dk/api/users/create',
  apiUpdateUser: 'https://staging.asgcare.dk/api/users/update',
  apiDeleteUser: 'https://staging.asgcare.dk/api/users/delete/',
  apiRestoreUser: 'https://staging.asgcare.dk/api/users/restore/',

  apiGetCompanyInfoFromCVR: 'https://staging.asgcare.dk/api/cvr/company/',
  apiGetCompanyWithSubsidiaryFromCVR:
    'https://staging.asgcare.dk/api/cvr/companyWithSubsidiary/',

  apiGetCPRLogs: 'https://staging.asgcare.dk/api/cpr/log',
  apiGetInfoFromCPR: 'https://staging.asgcare.dk/api/cpr/get',

  apiApplyForSJFInsurance: 'https://staging.asgcare.dk/api/forsia/apply',

  apiApplyForHelvetiaInsurance:
    'https://staging.asgcare.dk/api/application/helvetia',
  apiApplyForHelvetiaInsuranceNoAuth:
    'https://staging.asgcare.dk/api/helvetia/apply',
  apiApplyForHelvetiafleetPolicie:
    'https://staging.asgcare.dk/api/helvetia/riskItem/add',
  apiHelvetiaPrice: 'https://staging.asgcare.dk/api/helvetia/price',

  apiImpersonate: 'https://staging.asgcare.dk/api/impersonate/',

  apiGetSettings: 'https://staging.asgcare.dk/api/settings/get',
  apiUpdateSettings: 'https://staging.asgcare.dk/api/settings/update',
  apiGetFragusCommissions: 'https://staging.asgcare.dk/api/powertrain/fragus-commission/get',
  apiUpdateFragusCommissions: 'https://staging.asgcare.dk/api/powertrain/fragus-commission/update',

  apiGetDealers: 'https://staging.asgcare.dk/api/dealers/getAll',
  apiGetDealerByID: 'https://staging.asgcare.dk/api/dealers/get/',
  apiDeleteDealerByID: 'https://staging.asgcare.dk/api/dealers/delete/',
  apiUpdateDealer: 'https://staging.asgcare.dk/api/dealers/update',
  apiCreateDealer: 'https://staging.asgcare.dk/api/dealers/create',
  apiRestoreDealer: 'https://staging.asgcare.dk/api/dealers/restore/',

  apiGetInsurancePrices:
    'https://staging.asgcare.dk/api/insurance-info/get/prices',

  apiGetVehicleFromDMRByVIN: 'https://staging.asgcare.dk/api/vehicle-info/vin/',
  apiGetVehicleFromDMRByReg: 'https://staging.asgcare.dk/api/vehicle-info/reg/',

  apiScrapeVehicleFromDMRByVIN: 'https://staging.asgcare.dk/api/vehicle-info/vin/live/',
  apiScrapeVehicleFromDMRByReg: 'https://staging.asgcare.dk/api/vehicle-info/reg/live/',

  apiGetSubsidiaries: 'https://staging.asgcare.dk/api/subsidiaries/getAll',
  apiGetSubsidiaryById: 'https://staging.asgcare.dk/api/subsidiaries/get/',
  apiUpdateSubsidiary: 'https://staging.asgcare.dk/api/subsidiaries/update',

  apiGetLeads: 'https://staging.asgcare.dk/api/leads/getAll',
  apiGetSortedLeads: 'https://staging.asgcare.dk/api/leads/get',
  apiUpdateLead: 'https://staging.asgcare.dk/api/lead-status/update',

  apiGetPriceTag: 'https://staging.asgcare.dk/api/price-tag',

  apiGetKsfTemplate: 'https://staging.asgcare.dk/api/kf/template',
  apiGetInitialKsfPrice: 'https://staging.asgcare.dk/api/kf/price',
  apiUpdateKsfTemplate: 'https://staging.asgcare.dk/api/kf/template',
  apiApplyForKsf: 'https://staging.asgcare.dk/api/kf/confirm',

  apiApplyForPowerTrain: 'https://staging.asgcare.dk/api/powertrain/apply',
  apiGetPricePowerTrain: 'https://staging.asgcare.dk/api/powertrain/price',
  apiGetAddonsPowerTrain: 'https://staging.asgcare.dk/api/powertrain/addons',
  apiGetPowerTrainLead: 'https://staging.asgcare.dk/api/powertrain/get',

  apiGetCommissionById: 'https://staging.asgcare.dk/api/commission/get/',

  apiGetForsiaForwardedLeads:
    'https://staging.asgcare.dk/api/forsia/leads/internal/',
  apiGetForsiaPrices: 'https://staging.asgcare.dk/api/forsia/price',
  apiGetForsiaExcessPrices:
    'https://staging.asgcare.dk/api/forsia/referenceTable/excess',
  apiGetForsiaEquipmentTable:
    'https://staging.asgcare.dk/api/forsia/referenceTable/equipment',
  apiGetForsiaMileageTable:
    'https://staging.asgcare.dk/api/forsia/referenceTable/mileage',
  apiForwardLead: 'https://staging.asgcare.dk/api/forsia/insurance-lead',
  apiRefreshToken: 'https://staging.asgcare.dk/api/refresh-token',
};
